import {Injectable} from "@angular/core";
import {Pessoa} from "../../../domain/Pessoa";
import {AbstractSQLService} from "./AbstractSQLService";
import {Funcao} from "../../../domain/enums";

@Injectable()
export class PessoaSQLService extends AbstractSQLService<Pessoa>{
    nomeTabela = "pessoa"
  agenciavel = true

    async findByNome(nome: string, funcoes: Funcao[]): Promise<Pessoa[]> {

        let sql = "select * FROM pessoa where nome like ?"
        let params = [nome + '%']
        if(funcoes.length > 0) {
            const where = funcoes.map(f => 'funcoes like ?').join(" OR ")
            sql += " WHERE " + where
            params.push(...funcoes.map(f=> `%${f}%`))
        }
        const coll = await this.db.query(sql, params)
        return coll.values!!.map((r: any)=> this.toObject(r))

    }

  override toObject(row: any): any {
        row.funcoes = JSON.parse(row.funcoes)
        return row
    }
}
